import React from "react";

export default (props) => (
  <svg {...props} viewBox="0 0 11 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2934 5.23022L5.26822 10.2679C4.29318 11.2425 2.70711 11.2425 1.73257 10.2679C0.758032 9.29339 0.757532 7.70682 1.73257 6.73178L7.04679 1.43906C7.63182 0.854036 8.58336 0.854036 9.16838 1.43906C9.75291 2.02408 9.75341 2.97512 9.16838 3.56015L4.91471 7.79232C4.7197 7.98733 4.40268 7.98733 4.20768 7.79232C4.01267 7.59732 4.01267 7.2803 4.20768 7.08529L7.75432 3.56015L7.04679 2.85312L3.50015 6.37776C2.91412 6.96379 2.91462 7.91433 3.50015 8.49985C4.08567 9.08538 5.03571 9.08538 5.62123 8.49985L9.87491 4.26768C10.3634 3.77916 10.6069 3.13963 10.6069 2.4996C10.6069 1.11505 9.4839 0 8.10684 0C7.46681 0 6.82729 0.24401 6.33877 0.73253L1.02504 6.02425C0.342014 6.70828 0 7.60382 0 8.49985C0 10.4314 1.56507 12 3.50015 12C4.39618 12 5.29172 11.658 5.97525 10.975L11.0005 5.93725L10.2934 5.23022Z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Attach/index.js